<div class="root" *transloco="let t; read: 'permit.details.export'">
    <ng-container *ngIf="currentUserIsIssuer$ | async">
        <div class="buttons">
            <div class="buttons__export" [class.buttons__export--loading]="waitingForDownload" [downloadFile]="pdfUrl" (click)="beginDownload()"
                 (done)="endDownload()" [innerHTML]="t('export')"></div>
            <div class="buttons__email" (click)="openExportPermitEmailModal()" [innerHTML]="t('mail')"></div>
        </div>
    </ng-container>
</div>
